export default "/50f517735fec46580f19aae3e56e9fe21614ea75/11a14d9b63ec892bb84cea8c67204259.svg";